var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionExternalSensorColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 14H24V18H0V14Z",
    fill: "url(#paint0_linear_431_8099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C2 11.8954 2.89543 11 4 11H9.5C11.9853 11 14 13.0147 14 15.5C14 17.9853 11.9853 20 9.5 20H4C2.89543 20 2 19.1046 2 18V13Z",
    fill: "#5714CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13C5.55228 13 6 13.4477 6 14C6 14.5523 5.55228 15 5 15Z",
    fill: "#FFC30D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 15C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13L10.5 13C11.3284 13 12 13.6716 12 14.5C12 14.7761 11.7761 15 11.5 15H9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15C16 11.6863 13.3137 9 10 9V7C14.4183 7 18 10.5817 18 15H16Z",
    fill: "#5714CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15C20 9.47715 15.5228 5 10 5V3C16.6274 3 22 8.37258 22 15H20Z",
    fill: "#5714CC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_8099",
    x1: 1,
    y1: 16,
    x2: 24,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5714CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648256,
    stopColor: "#5714CC",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionExternalSensorColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_external_sensor_colored_day.8a58ae39ddb2ec7dc31cd121e45ec354.svg";
export { ForwardRef as ReactComponent };